import { Outlet, redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { authMiddleware } from '@/server/functions/auth'
import { getUserCreditsFn } from '@/server/functions/deployments'
import { NavBar } from './_protected/-components/navbar'

export const Route = createFileRoute('/_protected')({
  beforeLoad: async () => {
    const { currentUser } = await authMiddleware()

    if (!currentUser) {
      // Redirect to home if not signed in, since sign-in page is removed
      throw redirect({ to: '/' })
    }
    const credits = await getUserCreditsFn({
      data: { userId: currentUser?.$id || '' },
    })
    return {
      currentUser,
      credits: credits,
    }
  },
  component: ProtectedLayout,
})

function ProtectedLayout() {
  const { currentUser } = Route.useRouteContext()
  
  return (
    <>
      <NavBar currentUser={currentUser} />
      <Outlet />
    </>
  )
}
